var MockBotCommand;
(function (MockBotCommand) {
  MockBotCommand["Bot"] = "/bot";
  MockBotCommand["Card"] = "/card";
  MockBotCommand["Help"] = "/help";
  MockBotCommand["SendAttachment"] = "send attachment";
  MockBotCommand["SendBotMessage"] = "send bot message";
  MockBotCommand["SendSystemMessage"] = "send system message";
  MockBotCommand["SendTyping"] = "send typing";
  MockBotCommand["System"] = "/system";
})(MockBotCommand || (MockBotCommand = {}));
export default MockBotCommand;